import { OrderProductType } from "./order-product-type";
import { InternalOrderInfos } from "./internal-order-infos";

export class CreateInternalOrderRequest {
  assetId: number | null = 0;
  comment: string | null = null;
  productType: OrderProductType | null = null;
  parameters: InternalOrderInfos[] | null = null;

  constructor(init?: Partial<CreateInternalOrderRequest>) {
    Object.assign(this, init);
  }
}
